<p [ngClass]="styleClass" *ngIf="!loading && endDate$">
    {{endDate$ | datediff: startDate | async }} ~ {{textAdd}}
</p> 
<p class="flex justify-content-between mt-4">
    <button pButton pRipple type="button"
    icon="pi pi-arrow-left" 
    label="Volver" 
    class="p-button-raised p-button-outlined p-button-danger " 
    (click)="onClose()"></button>

    <button pButton pRipple type="button"
        icon="pi pi-caret-right" 
        label="Ver ruta" 
        class="p-button-raised p-button-outlined  " 
        (click)="onClose(true)"></button>
</p>